// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3qJFI","list":"BalanceDue_list__3hnlu","listRow":"BalanceDue_listRow__3TGZX","total":"BalanceDue_total__1G3Jo"};